// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"42af3b87","496":"42af3b87","571":"2f674f26","759":"985c9b91","870":"b98931b6"}[chunkId] + ".chunk.css";
};